import { Box, Checkbox, IconButton, List, ListItem, ListItemText, Modal } from '@mui/material'
import PropTypes from 'prop-types'
import { ReactComponent as MenuIcon } from '../../../../assets/Frame 25.svg'
import React from 'react'

const WidgetsOption = ({
  handelMenuClick,
  open,
  menuOpen,
  handleClose,
  checkedItems,
  items,
  handleToggle
}) => {
  return (
    <>
      <IconButton
        onClick={handelMenuClick}
        size="small"
        style={{ borderRadius: '4px' }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <MenuIcon />
      </IconButton>
      <Modal open={menuOpen} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '120px',
            right: '70px',
            transform: 'translate(-50%, -50%)',
            flexShrink: '0',
            borderRadius: '8px',
            background: '#242428'
          }}
        >
          <List style={{ padding: '12px 8px', background: '#242428', borderRadius: '8px' }}>
            {items.map(item => (
              <ListItem sx={{ margin: '1px !important' }} key={item} onClick={handleToggle(item)}>
                <Checkbox
                  sx={{
                    width: '16px',
                    height: '16px',
                    '&.Mui-checked': {
                      color: '#A4A4FF'
                    },
                    marginRight: '4px'
                  }}
                  checked={checkedItems.indexOf(item) !== -1}
                  tabIndex={-1}
                  disableRipple
                />
                <ListItemText
                  primary={item}
                  primaryTypographyProps={{
                    sx: {
                      color: '#FFF',
                      fontFamily: 'Nunito',
                      fontSize: '12px !important',
                      fontStyle: 'normal',
                      fontWeight: 500,
                      marginLeft: '8px',
                      marginRight: '32px',
                      lineHeight: 'normal',
                      leadingTrim: 'both',
                      textEdge: 'cap'
                    }
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Modal>
    </>
  )
}

export default WidgetsOption

WidgetsOption.propTypes = {
  handelMenuClick: PropTypes.func,
  open: PropTypes.bool,
  menuOpen: PropTypes.bool,
  items: PropTypes.array,
  handleClose: PropTypes.func,
  handleToggle: PropTypes.func,
  checkedItems: PropTypes.array
}
